"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisementsSliderCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./Card.scss");
const AdvertisementsSliderCard = (props) => {
    const { className, onClick, image } = props;
    const classNames = (0, classnames_1.default)('advertisements-slider-card', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames, onClick: onClick },
        react_1.default.createElement("img", { src: image, alt: 'advertisement', loading: 'lazy', className: 'advertisements-slider-card__image' })));
};
exports.AdvertisementsSliderCard = AdvertisementsSliderCard;
//# sourceMappingURL=Card.js.map